module.exports = __webpack_public_path__ + "img/alert_circle.2c06363d.svg";